import { render, staticRenderFns } from "./TableLocalV1Widget.vue?vue&type=template&id=7e41e87c&"
import script from "./TableLocalV1Widget.vue?vue&type=script&lang=js&"
export * from "./TableLocalV1Widget.vue?vue&type=script&lang=js&"
import style0 from "./TableLocalV1Widget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports